import {
  Type,
  AlignLeft,
  Mail,
  Phone,
  Hash,
  ChevronDown,
  ToggleLeft,
  Calendar,
  Image as ImageIcon,
  Images,
  Watch,
} from "lucide-react";

// Backend ke FormSchema field types se exactly match karta hai
export const FIELD_TYPES = [
  { type: "text", label: "Short text", icon: Type },
  { type: "textarea", label: "Long text", icon: AlignLeft },
  { type: "email", label: "Email", icon: Mail },
  { type: "phone", label: "Phone", icon: Phone },
  { type: "number", label: "Number", icon: Hash },
  { type: "select", label: "Dropdown", icon: ChevronDown },
  { type: "boolean", label: "Yes / No", icon: ToggleLeft },
  { type: "date", label: "Date", icon: Calendar },
  { type: "time", label: "Time", icon: Watch },
  { type: "datetime-local", label: "Date Time", icon: Calendar },
  { type: "image", label: "Image", icon: ImageIcon },
  { type: "image_multi", label: "Many images", icon: Images },
];

export const TYPE_META = Object.fromEntries(
  FIELD_TYPES.map((t) => [t.type, t]),
);
